import * as React from 'react'
import cx from 'classnames'
import { observer } from 'mobx-react'
import NoTasks from '../NoTasks'
import TaskListItem from '../TaskListItem'
import styles from './TaskList.sass'
import { TaskListViewModel } from '../MilestonesViewModel'

interface TaskListProps {
  list: TaskListViewModel
  isCardLayout?: boolean
}

export default observer(function TaskList({
  list,
  isCardLayout,
}: TaskListProps) {
  return (
    <div className={cx(styles.root)}>
      <div className={cx(styles.list)}>
        {list.tasks.length === 0 && <NoTasks />}
        {list.tasks.map((taskItem) => (
          <TaskListItem
            isCardLayout={isCardLayout}
            key={taskItem.taskItem.id}
            item={taskItem}
          />
        ))}
      </div>
    </div>
  )
})
